import series from '@/api/modules/series'

const getDefaultState = () => {
  return {
    list: []
  }
}

const state = getDefaultState()

const actions = {
  fetch (context, cached = true) {
    const { list } = context.state
    if (cached && list.length) {
      return Promise.resolve(list)
    }

    return series.fetch()
      .then(data => context.commit('fetch', data))
  },

  resetState (context) {
    context.commit('resetState')
  }
}

const mutations = {
  fetch (state, data) {
    state.list = data
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations
})
